import { Box, Grid } from "@material-ui/core";
import React, { useCallback } from "react";
import { EXCEL_FORMAT_TYPE, UploaderWithTips } from "components/upload/uploader-with-tips-view";
import { formatMessage } from "lib/globalize-util";
import { MAX_FILE_SIZE } from "components/product-collection/manage-allocation-dimension/import-door-attributes/utils";
import { useFileSpecificationsAndTipsForUpload } from "./file-specifications-and-tips-for-upload";
import { useTargetsUploader } from "components/product-collection/footer/components/hooks/useTargetsUploader/use-targets-uploader";
import { ErrorWhileUploadingFile } from "components/product-collection/manage-allocation-dimension/import-door-attributes/error-message-while-processing";
import { ITargetsData } from "components/product-collection/footer/types";

interface IProps {
    handleSuccessfulUpload?: (uploadedTargetsData: ITargetsData[]) => void;
}

export const UploadContainer: React.FunctionComponent<IProps> = ({ handleSuccessfulUpload }) => {
    const [isUpdating, setIsUpdating] = React.useState(false);
    const { handleDrop, isUploading, wasProcessed, errorMessages, hasDataToChange, parsedTargetsData } =
        useTargetsUploader();
    const messageTips = useFileSpecificationsAndTipsForUpload();
    const hasErrors = Object.keys(errorMessages ?? {}).length > 0;

    const handleCallbackCloseAlert = React.useCallback(() => {}, []);

    const getErrorMessage = useCallback((): React.ReactNode => {
        if (hasErrors) {
            return <ErrorWhileUploadingFile errorMessages={errorMessages} />;
        }
        return null;
    }, [errorMessages, hasErrors]);

    if (!hasErrors && wasProcessed === true) {
        handleSuccessfulUpload(parsedTargetsData);
    }

    return (
        <Grid container spacing={4}>
            <Grid item xs={12}>
                <Box maxWidth="74.9rem" marginX="auto" paddingY={4}>
                    <UploaderWithTips
                        title={formatMessage(
                            "To add new or modify existing target values from an offline spreadsheet, upload a file below. If you upload a target, such as class, all door and delivery values within that class target will be replaced. However, you do not have to upload all selected targets within a target."
                        )}
                        maxFileSize={MAX_FILE_SIZE}
                        formatType={EXCEL_FORMAT_TYPE}
                        onDrop={handleDrop}
                        tips={messageTips}
                        hasError={hasErrors}
                        errorMessage={getErrorMessage()}
                        isUploading={isUploading || isUpdating}
                        wasProcessed={wasProcessed}
                        hasDataToChange={hasDataToChange}
                        callbackCloseAlert={handleCallbackCloseAlert}
                    />
                </Box>
            </Grid>
        </Grid>
    );
};
